export const FirebaseConfig = {
	"projectId": "voobahx",
	"appId": "1:685915260204:web:b167c6be4b6c490eee5889",
	"databaseURL": "https://voobahx-default-rtdb.firebaseio.com",
	"storageBucket": "voobahx.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCjtVugVZH0OhNZgygh1vhu9tg3vD3EYeY",
	"authDomain": "voobahx.firebaseapp.com",
	"messagingSenderId": "685915260204",
	"measurementId": "G-04VY1N0VS3"
};